import { render } from "./PatientsDatatableTDDocumentFile.vue?vue&type=template&id=f1b4d138&scoped=true"
import script from "./PatientsDatatableTDDocumentFile.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDDocumentFile.vue?vue&type=script&lang=js"

import "./PatientsDatatableTDDocumentFile.vue?vue&type=style&index=0&id=f1b4d138&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b4d138"]])

export default __exports__